import { bl_ppl_from_peppol_doc_hdr_history_RowClass } from '../../../dbschema/bl_ppl_from_peppol_doc_hdr_history.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolFromPeppolDocHdrHistoryContainerModel extends BaseContainerModel {
    bl_ppl_from_peppol_doc_hdr_history: bl_ppl_from_peppol_doc_hdr_history_RowClass = new bl_ppl_from_peppol_doc_hdr_history_RowClass();
}